module.exports = __webpack_public_path__ + "static/media/PachelbelPeace_200.b1fbe791.jpg";